import StorageService from '@js/modules/storage';

import {userStore} from '@js/stores/userStore';

import {showProductModal} from '@js/actions/basketActions';
import {requireAccount} from '@js/actions/accountActions';

// Boolean "account required" gate. When the feature flag is on for the current role
// (a visitor gets the visitor flags), run the action; otherwise open the account modal
// and resume the action once the user is connected. Distinct from consumeFeatureUse,
// which is a numeric per-role cap surfacing the Explorer paywall.
export const requireAccountFeature = (flag, onGranted) => {
    if (userStore.featureFlags?.[flag]) {
        onGranted?.();

        return true;
    }

    requireAccount(flag, onGranted);

    return false;
};

// Generic freemium limit gate. Returns true when the action is allowed (and consumes one use for the
// session), false when the per-role cap is reached (and surfaces the paywall, which also records the
// limit-reached tracking). A null/undefined cap = unlimited (e.g. Explorer) → always allowed.
//
// Never blocks the site itself: callers use it only to gate a specific optional feature, letting the
// visitor try it a few times before the paywall kicks in.
export const consumeFeatureUse = (flag) => {
    const cap = userStore.featureFlags?.[flag];

    // No cap configured for this role → unlimited.
    if (cap === null || cap === undefined) {
        return true;
    }

    const key = `feature-use-${flag}`;
    const used = parseInt(StorageService.getItem(key) || '0', 10) || 0;

    if (used >= cap) {
        showProductModal(flag);

        return false;
    }

    StorageService.setItem(key, String(used + 1));

    return true;
};
